var map = {
	"./ButtonData": 595,
	"./ButtonData.js": 595,
	"./Category": 541,
	"./Category.jsx": 541,
	"./images/action.jpg": 279,
	"./images/adventure.jpg": 550,
	"./images/animation.jpg": 844,
	"./images/bg.jpg": 970,
	"./images/comedy.jpg": 798,
	"./images/crime.jpg": 682,
	"./images/documentary.jpg": 630,
	"./images/drama.jpg": 854,
	"./images/family.jpg": 26,
	"./images/fantasy.jpg": 639,
	"./images/history.jpg": 308,
	"./images/horror.jpg": 276,
	"./images/imgHolder.jpg": 351,
	"./images/music.jpg": 693,
	"./images/mystery.jpg": 559,
	"./images/romance.jpg": 521,
	"./images/sciencefiction.jpg": 721,
	"./images/thriller.jpg": 239,
	"./images/war.jpg": 386,
	"./images/western.jpg": 856,
	"./styling/Category.scss": 708,
	"./styling/Modal.scss": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 951;